import appConfig from 'app.config'

export const appRoutes = {
	startpage: '/',
	login: '/login',
	callbackPage: '/callback',
	norwegianBankIdCallback: '/norwegianbankidcallback',
	logout: '/logout',
	logoutcallback: '/logoutcallback',
	cardApplicationPage: '/cardapplication',
	cardApplicationLogin: '/cardapplicationlogin',
	paymentVerification: '/auth/payment-verification',
	sepadirectdebit: '/sepadirectdebit',
	referfriends: '/referfriends',
	revokeaddresschange: '/revokeaddresschange/:id',
}

export const apiRoutes = {
	getCreditCardData: (customerId: string) =>
		`${appConfig.customerDataBaseUrl}/api/creditcard/creditcard?customerId=${customerId}&includeBlockedAuthorizations=true`,
	getTransactions: (
		accountAgreementId: string,
		accountTransactionDate: string,
	) =>
		`${appConfig.customerDataBaseUrl}/api/creditcard/transactions?accountAgreementId=${accountAgreementId}&accountTransactionDate=${accountTransactionDate}&pageSize=9999999&language=${appConfig.country}&includeBlockedAuthorizations=true`,
	getTransactionsByDates: (
		accountAgreementId: string,
		startDate: string,
		endDate: string,
	) =>
		`${appConfig.customerDataBaseUrl}/api/creditcard/paged/transactions?accountAgreementId=${accountAgreementId}&startDate=${startDate}&endDate=${endDate}&language=${appConfig.country}&includeBlockedAuthorizations=true`,
	getCustomer: (customerId: string, birthDate: string) =>
		`${appConfig.customerDataBaseUrl}/api/user/mobileapp/customer?customerId=${customerId}&birthDate=${birthDate}`,
	updateCustomer: `${appConfig.customerDataBaseUrl}/api/user/mobileapp/updatecustomer`,
	getAccountStatements: (
		customerId: string,
		accountStatementFormat: string,
		additionalData: string,
	) =>
		`${appConfig.customerDataBaseUrl}/api/creditcard/accountstatements?customerId=${customerId}&accountStatementFormat=${accountStatementFormat}&additionalData=${additionalData}`,
	getAccountStatement: (accountStatementId: string) =>
		`${appConfig.customerDataBaseUrl}/api/creditcard/accountstatement?accountStatementId=${accountStatementId}`,
	getPinUrl: (cardId: number, country: string) =>
		`${appConfig.customerDataBaseUrl}/api/creditcard/pin/url?cardId=${cardId}&iMSGetPinCountryType=${country}`,
	setPassword: `${appConfig.customerDataBaseUrl}/api/enrollment/onlinepurchase/enrollcard`,
	getDepositData: (customerId: string) =>
		`${appConfig.customerDataBaseUrl}/api/deposit/agreement?customerId=${customerId}`,
	getDepositTransactions: (
		accountAgreementId: string,
		accountTransactionDate: string,
	) =>
		`${appConfig.customerDataBaseUrl}/api/deposit/transactions?accountAgreementId=${accountAgreementId}&accountTransactionDate=${accountTransactionDate}&pageSize=9999999&language=${appConfig.country}`,
	sendEmailSsp: `${appConfig.customerDataBaseUrl}/api/support/ssp/email`,
	getAccountStatementsDeposit: (
		customerId: string,
		accountStatementFormat: string,
		additionalData: string,
	) =>
		`${appConfig.customerDataBaseUrl}/api/deposit/accountstatements?customerId=${customerId}&accountStatementFormat=${accountStatementFormat}&additionalData=${additionalData}`,
	getAccountStatementDeposit: (accountStatementId: string) =>
		`${appConfig.customerDataBaseUrl}/api/deposit/accountstatement?accountStatementId=${accountStatementId}`,
	getAnnualReport: (accountAgreementId: string) =>
		`${appConfig.customerDataBaseUrl}/api/creditcard/annualreport?accountAgreementId=${accountAgreementId}`,
	updateCardStatus: `${appConfig.customerDataBaseUrl}/api/creditcard/updatecardstatus`,
	orderNewCard: `${appConfig.customerDataBaseUrl}/api/creditcard/newcard`,
	getAgreementHistory: () =>
		`${appConfig.customerDataBaseUrl}/api/creditcard/agreements`,
	getMaintenanceInfo: (market: string) =>
		`${appConfig.customerDataBaseUrl}/api/customerservice/maintenance/next?market=${market}`,
	getMarketingData: (market: string) =>
		`${appConfig.customerDataBaseUrl}/api/customerservice/marketing/next?market=${market}`,
}
